import React from 'react'
function Gallery() {
    return (
        <div>
        </div>
    )
}
export default Gallery
